import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logPostInfo, logging } from '../../actions/log';
import { CONTEXT } from '../../config';
import { getSearchRecommend } from '../../actions/search';
import Button from '../Button/Button';
import Rate from '../Rate/Rate';
import styles from './NSLineCard.module.less';
import gift from '../../static/search_gift.svg';
import reco from '../../static/search_reco.svg';
import sale from '../../static/search_sale.png';
import essence from '../../static/search_essence.png';
import MyLink from '../Link/Link';
import DEFAULTIMG from '../../static/default.svg';
import SoftMetaSwiper from '../SoftMetaSwiper/SoftMetaSwiper';

import { formatMoney, getSoftType } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ soft, logInfo, info }) => {
  const dispatch = useDispatch();
  const installedSoftInit = useSelector(selectInstalledSoft);
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftBtn = useCallback(
    _soft => {
      const found = installedSoftInit.find(
        soft_ => soft_.softID === _soft.softID || soft_.SoftID === _soft.softID,
      );
      if (!found) {
        dispatch(
          getSearchRecommend({
            softInfo: _soft.softID,
            androidType: _soft.androidType || 0,
            soruce: 'search',
          }),
        );
      }
    },
    [dispatch, installedSoftInit],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'LineCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          softid: soft?.softID,
          softType: getSoftType(soft),
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        ...logInfoData,
        source,
        source_p: logInfo.source,
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  // 专题商品文字链接
  const handleClickAD = () => {
    // 专题商品文字链接
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Buy_Text',
        label: '',
        param2: {
          source: logInfo ? logInfo.source : 'LineCard_err',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          softId: soft.softID,
          softType: soft.androidType || 0,
          targetContent:
            soft && soft.activityList && soft.activityList[0].targetContent
              ? JSON.parse(soft.activityList[0].targetContent)
              : '',
          targetType: soft && soft.activityList && soft.activityList[0].targetType,
        },
        param3: soft && soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${logInfo ? logInfo.source : 'LineCard_err'}||Search_Activity`,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  // 搜索结果页-商品活动文字链展现
  useEffect(() => {
    if (soft && soft.activityList && soft.activityList[0]) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Buy_Text',
          label: '',
          param2: {
            source: logInfo ? logInfo.source : 'LineCard_err',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            softid: soft.softID,
            softType: soft.androidType || 0,
            targetContent:
              soft && soft.activityList && soft.activityList[0].targetContent
                ? JSON.parse(soft.activityList[0].targetContent)
                : '',
            targetType: soft && soft.activityList && soft.activityList[0].targetType,
          },
          param3: soft && soft.bizInfo,
        }),
      );
    }
  }, []);
  // 商务首位图片/视频的展现
  useEffect(() => {
    if (soft?.showCaptureFileList === '1' && soft?.captureFileList) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Business_Show',
          label: '',
          param2: {
            source: logInfo ? logInfo.source : 'LineCard_err',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            softid: soft.softID,
            softType: soft.androidType || 0,
          },
          param3: soft && soft.bizInfo,
        }),
      );
    }
  }, []);

  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      return discont;
    }
    return '0';
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  return (
    <>
      <div
        className={styles.card}
        style={
          soft && soft.showCaptureFileList === '1' && soft.captureFileList ? { border: 'none' } : {}
        }
      >
        <div className={styles.card_content}>
          <Link
            to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=${
              logInfo?.isSearch
            }`}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            <div className={styles.img_container}>
              <div className={styles.app_img}>
                <img className={styles.app_img} src={soft.logoFile || DEFAULTIMG} alt="" />
              </div>
              {soft.hasGiftBag && <img src={gift} alt="" className={styles.logo_icon} />}
              {!soft.hasGiftBag && soft.editorRecommend && (
                <img src={reco} alt="" className={styles.logo_icon} />
              )}
            </div>
          </Link>
          <div className={styles.info}>
            <Link
              to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=${
                logInfo?.isSearch
              }`}
              onClick={() => {
                handleSoftCard(soft);
              }}
              title={soft.softName}
            >
              <div className={styles.info_container}>
                <div className={styles.title_info}>
                  <div
                    className={
                      soft?.searchTag && soft?.searchTag?.length > 0 ? styles.title_ : styles.title
                    }
                    title={soft?.softName?.length > 5 ? soft?.softName : ''}
                  >
                    {soft.softName}
                  </div>
                  {soft?.searchTag && soft?.searchTag?.length > 0 && (
                    <div className={styles.table}>
                      {soft.searchTag.map((item, i) => (
                        <img
                          src={item.icon}
                          key={i}
                          alt={item.name || ''}
                          title={item.tips || ''}
                        />
                      ))}
                    </div>
                  )}
                </div>
                <div className={styles.desc} title={soft.introduction}>
                  {soft.introduction}
                </div>
              </div>
            </Link>

            {soft.activityList && soft.activityList[0] && soft.activityList[0].activityDesc && (
              <MyLink data={soft.activityList[0]} handleClick={handleClickAD}>
                <div className={styles.link}>
                  {/* 5商品 2是外链 11专题详情 */}
                  <img src={soft.activityList[0].targetType === '5' ? sale : essence} alt="" />
                  <div
                    className={styles.ad}
                    title={
                      soft.activityList[0].activityDesc.length > 18
                        ? soft.activityList[0].activityDesc
                        : null
                    }
                  >
                    {soft.activityList[0].activityDesc}
                  </div>
                  <div className={styles.ad_arrow} />
                </div>
              </MyLink>
            )}
          </div>

          <div className={styles.size}>
            <div className={styles.size_desc}>{soft.installFileSize}</div>
            <div className={styles.size_download}>{soft.downloadCount}安装</div>
          </div>
          <div className={styles.score}>
            <div className={styles.score_detail}>
              <div className={styles.score_icon}>
                <Rate score={(Number(soft.score) / 20).toFixed(1)} />
              </div>
              <span className={styles.val}>{(Number(soft.score) / 20).toFixed(1)}</span>
            </div>
            <div className={styles.score_count}>{soft.commentUserCount}人打分</div>
          </div>

          <div
            className={styles.opt_div}
            onClick={() => {
              if (soft && soft?.payType !== 1) {
                handleSoftBtn(soft);
              }
            }}
          >
            <Button
              soft={soft}
              info={{
                ...info,
                className: styles.soft_btn,
                className_busing: styles.soft_btn_b,
                className_open: styles.soft_button_open,
              }}
              logInfo={logInfo}
            />

            {soft && soft?.payType === 1 && (
              <div
                className={styles.soft_buyInfos}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {soft?.originalPrice &&
                  soft?.currentPrice &&
                  soft?.originalPrice !== soft?.currentPrice && (
                    <>
                      <div className={`soft_buyInfos_zk`}>
                        {formatDiscount(soft?.currentPrice, soft?.originalPrice)} 折
                      </div>
                      <div className={`soft_buyInfos_cp`}>
                        <span className={`soft_buyInfos_cp_1`}>￥</span>
                        <span className={`soft_buyInfos_cp_2`}>
                          {formatMoney(parseFloat((soft?.currentPrice || 0) / 100))}
                        </span>
                      </div>
                      <div className={`soft_buyInfos_op`}>
                        {`￥${formatMoney(parseFloat((soft?.originalPrice || 0) / 100))}`}
                      </div>
                    </>
                  )}

                {((!soft?.originalPrice && soft?.currentPrice) ||
                  (soft?.originalPrice && !soft?.currentPrice) ||
                  (soft?.originalPrice &&
                    soft?.currentPrice &&
                    soft?.originalPrice === soft?.currentPrice)) && (
                  <>
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>￥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatMoney(
                          parseFloat((soft?.currentPrice || soft?.originalPrice || 0) / 100),
                        )}
                      </span>
                    </div>
                  </>
                )}
              </div>
            )}
            {soft && soft?.androidType === '3' && soft?.sourceInfo && (
              <div
                className={styles.soft_buyInfos}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {soft?.sourceInfo?.sellInfo?.discount && (
                  <div className={`soft_buyInfos_zk`}>
                    {soft?.sourceInfo?.sellInfo?.discount} 折
                  </div>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice ===
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    {(soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice) ||
                      (!soft?.sourceInfo?.sellInfo?.currentPrice &&
                        soft?.sourceInfo?.sellInfo?.originalPrice && (
                          <div className="soft_buyInfos_cp">
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(
                                soft?.sourceInfo?.sellInfo?.currentPrice ||
                                  soft?.sourceInfo?.sellInfo?.originalPrice,
                              )}
                            </span>
                          </div>
                        ))}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_cp`}>
                          <span className={`soft_buyInfos_cp_1`}>￥</span>
                          <span className={`soft_buyInfos_cp_2`}>
                            {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                          </span>
                        </div>
                      )}
                  </>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice !==
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_cp`}>
                          <span className={`soft_buyInfos_cp_1`}>￥</span>
                          <span className={`soft_buyInfos_cp_2`}>
                            {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                          </span>
                        </div>
                      )}
                    {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_cp`}>
                          <span className={`soft_buyInfos_cp_1`}>￥</span>
                          <span className={`soft_buyInfos_cp_2`}>
                            {formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                          </span>
                        </div>
                      )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <>
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                          <div className={`soft_buyInfos_op`}>
                            {`￥${formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}`}
                          </div>
                        </>
                      )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {soft?.showCaptureFileList === '1' && soft?.captureFileList && (
        <div className={styles.swiper}>
          <SoftMetaSwiper
            swiperData={soft?.captureFileList}
            appInfo={soft}
            width={191}
            height={120}
            logInfo={{
              source: logInfo ? logInfo.source : 'LineCard_err',
              action: `Search_Show_big`,
              param2: {
                search_type: logInfoData.search_type,
                search_word: logInfoData.search_word,
              },
            }}
            spaceBetween={12}
          />
        </div>
      )}
    </>
  );
});
